module.exports = __webpack_public_path__ + "static/img/invite_card.ba31719e.png";